export default class ProdutosEntrada {
  constructor(codProduto = "", precoComrpa = "", quantidade = "", codigoDeBarras = [], idSacola = null) {
    this.IdProduto = codProduto
    this.PrecoCompra = precoComrpa
    this.Quantidade = quantidade
    this.CodigoDeBarras = codigoDeBarras
    this.idSacola = idSacola
  }
}
